/**
 * Reads the Learning-Framework auth headers from the stored token bundle.
 * Mirrors the inline getAuthHeaders() in the LL hooks — used by org-level admin
 * surfaces (e.g. Org Members Program View) that call the /v3/admin/* endpoints,
 * which expect idtoken / authorization as explicit headers.
 */
import { readSessionProfile } from '../auth/session';

export const getLLAuthHeaders = (): {
  idtoken: string;
  authorization: string;
  orgid: string;
} => {
  try {
    const raw = localStorage.getItem('tokens');
    const tokens = raw ? JSON.parse(raw) : {};
    const accessRaw = tokens.access_token || '';
    let orgid = '';
    try {
      const payload = JSON.parse(atob(accessRaw.split('.')[1] || ''));
      orgid = payload?.['https://dosen.io/organization']?.id || '';
    } catch {
      // malformed token — orgid stays empty
    }
    // Transparent authentication: the tokens carry no organization claim — the session does.
    if (!orgid) orgid = readSessionProfile()?.organization?.id || '';
    return {
      idtoken: tokens.id_token || '',
      authorization: tokens.access_token || '',
      orgid
    };
  } catch {
    return { idtoken: '', authorization: '', orgid: '' };
  }
};
